<template>
  <div :class="['filter-item', {_active: isActive}]" @click="clickHandler">
    <span class="filter-name">
      {{ filterName }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'filter-item',

  props: {
    filterName: {
      type: String,
      default: '',
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    clickHandler() {
      this.$emit('change-filter', this.filterName);
    },
  },
};
</script>

<style scoped lang="scss">
.filter-item {
  margin-bottom: 5px;
  padding: 14px 25px 12px;
  border: 1px solid #E5E5E5;
  border-radius: 4px;
  cursor: pointer;
  transition: border .2s;

  &._active {
    border-color: #000000;
    cursor: default;
    pointer-events: none;
  }

  .filter-name {
    white-space: nowrap;
    font-size: 17px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.8px;
    color: #333332;
  }
}
</style>
